import {Component, OnInit} from '@angular/core';
import {MatFormField} from "@angular/material/form-field";
import {MatOption, MatSelect} from "@angular/material/select";
import {MatInput, MatInputModule} from "@angular/material/input";
import {FormControl, FormGroup, ReactiveFormsModule, Validators} from "@angular/forms";
import {NgxIntlTelInputModule} from "@justin-s/ngx-intl-tel-input";
import {TranslateModule} from "@ngx-translate/core";
import {BirthdateDividedComponent} from "../../../shared/components/ux/birthdate-divided/birthdate-divided.component";
import {MatCheckbox} from "@angular/material/checkbox";
import {MatChip, MatChipSet} from "@angular/material/chips";
import {
  AccommodationCityInputComponent
} from "../../../pages/processes/accommodation/components/accommodation-city-input/accommodation-city-input.component";
import {
  MatAccordion,
  MatExpansionPanel,
  MatExpansionPanelDescription, MatExpansionPanelHeader,
  MatExpansionPanelTitle
} from "@angular/material/expansion";
import {MatPaginator} from "@angular/material/paginator";
import {MatSlider, MatSliderThumb} from "@angular/material/slider";
import {MatTabLink, MatTabNav, MatTabNavPanel} from "@angular/material/tabs";
import {NgbTooltip} from "@ng-bootstrap/ng-bootstrap";
import {NgxSliderModule, Options} from "@angular-slider/ngx-slider";
import {
  AccommodationPhotoComponent
} from "../../../shared/components/accommodation-specific/accommodation-photo/accommodation-photo.component";
import {NeedHelpComponent} from "../../../shared/components/ux/need-help/need-help.component";
import {NgClass, NgIf} from "@angular/common";
import {MatSelectCountryModule} from "@angular-material-extensions/select-country";
import {MatIconButton} from "@angular/material/button";
import {MatMenu, MatMenuItem, MatMenuTrigger} from "@angular/material/menu";
import {MatIcon} from "@angular/material/icon";
import {IconComponent} from "../../../shared/components/icons-svgs/icons-svgs.component";
import iconsSvgs from "../../../models/icons-svgs";

@Component({
  selector: 'app-dev-kit',
  standalone: true,
  imports: [
    MatFormField,
    MatSelect,
    MatOption,
    MatInput,
    MatInputModule,
    ReactiveFormsModule,
    NgxIntlTelInputModule,
    TranslateModule,
    BirthdateDividedComponent,
    MatCheckbox,
    MatChipSet,
    MatChip,
    AccommodationCityInputComponent,
    MatAccordion,
    MatExpansionPanel,
    MatExpansionPanelTitle,
    MatExpansionPanelDescription,
    MatExpansionPanelHeader,
    MatPaginator,
    MatSlider,
    MatSliderThumb,
    MatTabNav,
    MatTabLink,
    MatTabNavPanel,
    NgbTooltip,
    NgxSliderModule,
    AccommodationPhotoComponent,
    NeedHelpComponent,
    NgClass,
    MatSelectCountryModule,
    MatIconButton,
    MatMenuTrigger,
    MatIcon,
    MatMenu,
    MatMenuItem,
    IconComponent,
    NgIf
  ],
  templateUrl: './dev-kit.component.html',
  styleUrl: './dev-kit.component.scss'
})
export class DevKitComponent implements OnInit{

  public form = new FormGroup({
    first: new FormControl(null, [Validators.required]),
    second: new FormControl(null, [Validators.required]),
    third: new FormControl(null, [Validators.required]),
    forth: new FormControl(null, [Validators.required]),
    gender: new FormControl(null, [Validators.required]),
    phone: new FormControl(null, [Validators.required]),
    nationality: new FormControl(null, [Validators.required]),
  })

  links = ['First', 'Second', 'Third'];
  activeLink = this.links[0];
  public priceSliderOptions: Options = {
    floor: 0,
    ceil: 50000,
    hideLimitLabels: true,
    hidePointerLabels: true,
    enforceRange: false
  };

  propertyPhotos = [
    {photo: 'https://randomcatgifs.com/wp-content/uploads/2018/07/cropped-0vaUsxH-1.png', cover_photo: 1},
    {
      photo: 'https://steamuserimages-a.akamaihd.net/ugc/1934887423646018342/A5A96476413238FEC7563045B3030808D33EA681/?imw=512&&ima=fit&impolicy=Letterbox&imcolor=%23000000&letterbox=false',
      cover_photo: 1
    },
    {photo: 'https://i.pinimg.com/474x/a7/e8/89/a7e889effe08ecbede2ddaafbecdbd66.jpg', cover_photo: 1},
    {photo: 'https://i.pinimg.com/236x/0d/c7/02/0dc7020e567d6d282bf0d7dec7104136.jpg', cover_photo: 1},
  ]

  room = {
    name: 'Mangouste la belle',
    id: 5,
  }
  selectedCity = 'Lille';
  IconArray = [];
  iconBg = null;

  ngOnInit() {
    this.IconArray = Object.keys(iconsSvgs);
  }

  public scroll(element): void {
    element.scrollIntoView({behavior: 'smooth'});
  }

  public  addBackground():void {
    if (this.iconBg) {
      this.iconBg = null;
    } else {
      this.iconBg = 'darkgray';
    }
  }
}
